module.exports = __webpack_public_path__ + "static/media/carlo-guareschi.91483cee.jpeg";